import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { api } from '../store/api/api';
import { ThreadExcerpt } from '../components/shelves/ThreadExcerpt';
import { NewThreadDialog } from '../components/shelves/newThread/NewThreadDialog';
import { InlineNewThreadButton } from '../components/shelves/newThread/InlineNewThreadButton';
import { AddCommentDialog } from '../components/shelves/comments/AddCommentDialog';
import { selectAllThreads, useGetThreadsQuery } from '../store/api/threadsApi';
import { useGetUsersQuery } from '../store/api/usersApi';
import { ThreadsPageSkeleton } from '../components/shelves/transitions/ThreadsPageSkeleton';

export function Index() {
  const dispatch = useDispatch();
  const {
    isUninitialized: threadsNotLoadedYet,
    isLoading: loadingThreads,
    data: threadsData,
    isError: loadingThreadsFailed,
  } = useGetThreadsQuery();
  const {
    isUninitialized: usersNotLoadedYet,
    isLoading: loadingUsers,
    data: users,
    isError: loadingUsersFailed,
  } = useGetUsersQuery();

  const threads = useSelector(selectAllThreads);

  useEffect(() => {
    if (threadsNotLoadedYet) dispatch(api.endpoints.getThreads.initiate());
    if (usersNotLoadedYet) dispatch(api.endpoints.getUsers.initiate());
  }, [dispatch, threadsData, threadsNotLoadedYet, users, usersNotLoadedYet]);

  return (
    <section className="container mx-auto mt-4 mb-16 max-w-[600px] break-words px-2 sm:mb-24 md:mt-0 2xl:max-w-2xl">
      <InlineNewThreadButton />
      <NewThreadDialog />
      {loadingThreads && loadingUsers ? <ThreadsPageSkeleton /> : ''}
      {threadsData && users ? (
        <ul className="grid divide-y divide-gray-200 overflow-hidden dark:divide-gray-800">
          {threads.map((thread) => (
            <li
              key={thread.id}
              className="py-2 hover:bg-indigo-500/5 dark:hover:bg-indigo-900/5"
            >
              <ThreadExcerpt thread={thread} />
            </li>
          ))}
        </ul>
      ) : (
        ''
      )}
      {loadingThreadsFailed || loadingUsersFailed ? (
        <div className="my-4">Nothing to see here</div>
      ) : (
        ''
      )}
      <AddCommentDialog />
    </section>
  );
}
